import * as localForage from 'localforage'
import UniversalStorage from '@vue-storefront/core/store/lib/storage'

export function beforeRegistration ({ Vue, config, store, isServer }) {
  Vue.prototype.$db.versioningCollection = new UniversalStorage(localForage.createInstance({
    name: 'versioning',
    storeName: 'versioning',
    driver: localForage['LOCALSTORAGE']
  }))
}
